import React, {useEffect, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {
  ModeleClient,
  modeleClientInitValues,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
} from '../../../../../components/Models'
import {KTIcon, KTSVG} from '../../../../../_metronic/helpers'
import {LoadingData} from '../../../../../components/LoadingData'
import {getClient, getClientDemandes, getClientOtherData} from '../../../../../components/requests'
import {useLocation} from 'react-router'
import {shouldDisplayFonctionnalite, toGmapQuery} from '../../../../../components/helpers'
import {useAuth} from '../../../../modules/auth'
import {Tooltip} from 'react-tooltip'
import {ClientDetails} from './client/ClientDetails'
import {ClientParametrage} from './client/ClientParametrage'
import {ClientAdresses} from './client/ClientAdresses'
import {ClientContacts} from './client/ClientContacts'
import {ClientDocument} from './client/ClientDocument'
import {ClientHistoriqueFacturation} from './client/ClientHistoriqueFacturation'
import {ClientEncours} from './client/ClientEncours'
import {ClientRemises} from './client/ClientRemises'
import {ClientAcomptes} from './client/ClientAcomptes'
import {ReseauClientListPage} from '../../../ReseauClient/ReseauClientListPage'
import {DemandListPage} from '../../../demande/pages/DemandListPage'
import SavCarteDossiers from '../../../sav/components/SavCarteDossiers'

type LocationState = {
  fromDemande: boolean
  filters: any
}

interface ClientProps {
  dataClient?: any
  dataOther?: any
  setClientAdresseEdit?: any
  refetchClientData?: any
  setRefetchClientData?: any
}

const ClientShowPage = (
  {
    dataClient = null,
    dataOther = null,
    setClientAdresseEdit,
    refetchClientData,
    setRefetchClientData
  }: ClientProps) => {
  const location = useLocation()
  const navigate = useNavigate()

  let {clientId} = useParams()
  let idClient = clientId ?? dataClient?.id

  const [activeTag, setActiveTag] = useState('ficheClient')

  const [data, setData] = useState<ModeleClient>(modeleClientInitValues)
  const [isAcceptedBlocked, setIsAcceptedBlocked] = useState(false)
  const [totalAcceptedBlocked, setTotalAcceptedBlocked] = useState<number>(0)
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [loading, setLoading] = useState(true)
  const {currentUser} = useAuth()
  const state = location.state as LocationState | null

  useEffect(() => {
    if (dataClient !== null) {
      setData(dataClient)
      if (dataOther !== null) {
        setOtherData(dataOther)
      }
      setLoading(false)
    } else {
      getClientData()
      getClientDemandeData()
    }
  }, [idClient, dataClient])

  const getClientData = () => {
    getClient(idClient).then((clientRequest) => {
      if (clientRequest?.status === 200) {
        if (clientRequest?.data?.id !== undefined && clientRequest?.data?.id !== null) {
          const updatedData = Object.assign({...data}, clientRequest?.data)
          if (updatedData.pays?.id !== undefined) {
            updatedData.idPays = updatedData.pays?.id
          }
          setData({...updatedData})
          getClientDataOthers(idClient)
        }
        setLoading(false)
      } else {
        navigate(`/vente/clients/liste`)
      }
    })
  }

  const getClientDemandeData = () => {
    getClientDemandes(idClient).then((response) => {
      if (response?.status === 200) {
        const data = response?.data
        let count = 0
        data?.map((demande) => {
          if (demande?.clientDemandeEtape?.code === 'BLOQU') {
            setIsAcceptedBlocked(true)
            count += 1
          }
        })
        setTotalAcceptedBlocked(count)
      }
    })
  }

  const getClientDataOthers = (idClient) => {
    getClientOtherData(idClient, null).then((clientRequest) => {
      if (clientRequest?.status === 200) {
        const updatedData = Object.assign({...data}, clientRequest?.data)
        setOtherData({...updatedData})
      }
    })
  }

  const calcRatio = (demandesOk, demandesPasOk) => {
    if (demandesOk === undefined || demandesOk === 0) {
      return 0.0
    }
    if (demandesPasOk === undefined || demandesPasOk === 0) {
      return 100.0
    }
    return ((demandesOk / (demandesOk + demandesPasOk)) * 100).toFixed(2)
  }

  const handleNavigateToPreviousPage = () => {
    if (state?.fromDemande) {
      navigate('/demandes/liste', {
        state: {filters: state?.filters},
      })
    } else {
      navigate('/vente/clients/liste')
    }
  }

  //affichage du lien nav sur la fiche client
  const NavLinkItem = ({url, titre, tagName}) => (
    <li className='nav-item'>
      {!dataClient ? (
        <Link
          className={
            `nav-link text-active-primary me-6 ` +
            (location.pathname === `/vente/clients/${idClient}/afficher${url}` ||
            location.pathname === `/vente/clients/${idClient}/afficher${url}/ajouter`
              ? 'active'
              : '')
          }
          to={`/vente/clients/${idClient}/afficher${url}`}
        >
          {titre}
          {isAcceptedBlocked && tagName === 'demande' && (
            <>
              <span className='ms-3 fs-3 fw-bold bi bi-exclamation-circle text-danger tooltip-client-demande'></span>
              <Tooltip anchorSelect='.tooltip-client-demande' place='top'>
                {totalAcceptedBlocked} demande{totalAcceptedBlocked > 1 && 's'} acceptée
                {totalAcceptedBlocked > 1 && 's'} bloquée
                {totalAcceptedBlocked > 1 && 's'} !
              </Tooltip>
            </>
          )}
        </Link>
      ) : (
        <span
          className={`nav-link text-active-primary me-6 ` + (activeTag === tagName && 'active')}
          onClick={() => setActiveTag(tagName)}
          style={{cursor: 'pointer'}}
        >
          {titre}
        </span>
      )}
    </li>
  )

  return (
    <>
      {loading ? (
        <LoadingData/>
      ) : (
        <>
          <div className='card mb-5 mb-xl-10' style={{background: dataClient ? '#80808014' : ''}}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='d-flex justify-content-between w-100'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <p className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1 mb-0'>
                          {data.professionnel ? (
                            <>{data.nomSociete}</>
                          ) : (
                            <>
                              {data.nom} {data.prenom}
                            </>
                          )}
                        </p>
                        {data?.prospect ? (
                          <span className='fw-bolder px-4 mx-3 badge badge-prosp'>PROSPECT</span>
                        ) : (
                          <span className='fw-bolder px-4 badge badge-light-primary'>CLIENT</span>
                        )}
                        {data.professionnel ? (
                          <span className='badge badge-prof fw-bolder px-4 mx-3'>
                            Professionnel
                          </span>
                        ) : (
                          <span className='badge badge-part fw-bolder px-4 mx-3'>Particulier</span>
                        )}
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <a
                          href={`https://www.google.com/maps/search/query=${toGmapQuery(
                            data.pays?.nom + ' ' + data.codePostal + ' ' + data.ville
                          )}`}
                          target={'_blank'}
                          className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                        >
                          <KTIcon iconName='geolocation' className='fs-4 me-1'/>
                          {data.pays?.nom}, {data.codePostal} {data.ville}
                        </a>
                      </div>
                    </div>
                  </div>
                  {!dataClient && (
                    <div>
                      <button
                        data-tooltip-id='tooltip'
                        data-tooltip-content='Revenir en arrière'
                        data-tooltip-place='right'
                        className='btn btn-light'
                        onClick={handleNavigateToPreviousPage}
                      >
                        <i className='ki-duotone ki-arrow-left fs-3'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                        Retour
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex overflow-auto justify-content-evenly h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap text-nowrap'>
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR FICHE') && (
                    <NavLinkItem url='' titre='Fiche client' tagName='ficheClient'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR PARAMETRAGE') && (
                    <NavLinkItem url='/parametrage' titre='Paramétrage' tagName='param'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR ADRESSE') && (
                    <NavLinkItem url='/adresses' titre='Adresses' tagName='adresse'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR CONTACTS') && (
                    <NavLinkItem url='/contacts' titre='Contacts' tagName='contact'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR DOCUMENT') && (
                    <NavLinkItem url='/document' titre='Document' tagName='document'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR HISTORIQUE') && (
                    <NavLinkItem
                      url='/historique-facturation'
                      titre='Historique facturation'
                      tagName='facturation'
                    />
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR ENCOURS') && (
                    <NavLinkItem
                      url='/client-encours-paiement'
                      titre='En cours'
                      tagName='clientEncours'
                    />
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR REMISES') && (
                    <NavLinkItem url='/remises' titre='Remises' tagName='remise'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR ACOMPTES') && (
                    <NavLinkItem url='/acomptes' titre='Acomptes' tagName='acompte'/>
                  )}
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR CLIENT DEMANDES') && (
                    <NavLinkItem url='/demandClient' titre='Demandes' tagName='demande'/>
                  )}
                  <NavLinkItem url='/reseau-client' titre='Réseaux' tagName='reseaux'/>
                </ul>
              </div>
            </div>
          </div>
          {/*/!*  affichage du contenu des informations clients tab du fiche client modal*!/*/}
          {dataClient && (
            <>
              {activeTag === 'ficheClient' && (
                <>
                  <ClientDetails dataClient={data}/>
                  <SavCarteDossiers clientId={idClient} />
                </>
              )}
              {activeTag === 'param' && (
                <ClientParametrage isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'adresse' && (
                <ClientAdresses
                  isFromModalClient={true}
                  idClient={idClient}
                  setClientAdresseEdit={setClientAdresseEdit}
                  refetchClientData={refetchClientData}
                  setRefetchClientData={setRefetchClientData}
                />
              )}
              {activeTag === 'contact' && (
                <ClientContacts isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'document' && (
                <ClientDocument isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'facturation' && (
                <ClientHistoriqueFacturation isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'clientEncours' && (
                <ClientEncours isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'remise' && (
                <ClientRemises isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'acompte' && (
                <ClientAcomptes isFromModalClient={true} idClient={idClient}/>
              )}
              {activeTag === 'demande' && (
                <DemandListPage SelectedClient={idClient} isFromModalClient={true}/>
              )}
              {activeTag === 'reseaux' && (
                <ReseauClientListPage isFromModalClient={true}/>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export {ClientShowPage}
